// extracted by mini-css-extract-plugin
module.exports = {"root":"Video_root__WILBQ","container":"Video_container__OZXzK","thumbnail":"Video_thumbnail__1D0G9","playButton":"Video_playButton__12-0w"};